// @ts-nocheck
if (!customElements.get('featured-filters')) {
  customElements.define('featured-filters', class FeaturedFilters extends HTMLElement {
    #isDown = false;
    #startX = 0;
    #scrollLeft = 0;
    #hasDragged = false;

    connectedCallback() {
        this.scrollContainer = this.querySelector('.featured-filters-scroll-container');
        if (!this.scrollContainer) return;

        this.#syncFromURL();

        window.addEventListener('popstate', this.#onURLChange);
        window.addEventListener('pushstate', this.#onURLChange);

        // Patch history.pushState to fire a custom event
        if (!window.__pushStatePatchted) {
            window.__pushStatePatchted = true;
            const originalPushState = history.pushState.bind(history);
            history.pushState = (...args) => {
            originalPushState(...args);
            window.dispatchEvent(new Event('pushstate'));
            };

            const originalReplaceState = history.replaceState.bind(history);
            history.replaceState = (...args) => {
            originalReplaceState(...args);
            window.dispatchEvent(new Event('replacestate'));
            };
        }

        window.addEventListener('replacestate', this.#onURLChange);

        // Restore active button from body class
        const activeValue = this.#getActiveFromBody();
        this.#setActiveButton(activeValue);
        

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            this.scrollContainer.addEventListener('mousedown', this.#onMouseDown);
            window.addEventListener('mousemove', this.#onMouseMove);
            window.addEventListener('mouseup', this.#onMouseUp);
            this.scrollContainer.addEventListener('click', this.#onClick, true);
        }

        this.querySelectorAll('[data-featured-filter]').forEach(button => {
            button.addEventListener('click', this.#onFilterClick);
        });
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.#onURLChange);
      window.removeEventListener('pushstate', this.#onURLChange);
      window.removeEventListener('replacestate', this.#onURLChange);
      window.removeEventListener('mousemove', this.#onMouseMove);
      window.removeEventListener('mouseup', this.#onMouseUp);
    }

    #onURLChange = () => {
        this.#syncFromURL();
    };

    #syncFromURL() {
        const url = new URL(window.location.href);
        const activeFilterValue = url.searchParams.get('filter.p.m.custom.featured_filters');

        document.body.classList.forEach(cls => {
            if (cls.startsWith('featured-filter-')) document.body.classList.remove(cls);
        });

        if (activeFilterValue) {
            const matchingButton = this.querySelector(`[data-value="${activeFilterValue}"]`);
            if (matchingButton) {
            document.body.classList.add(`featured-filter-${matchingButton.dataset.filterIndex}`);
            } else {
            document.body.classList.add('featured-filter-0');
            }
        } else {
            document.body.classList.add('featured-filter-0');
        }
    }

    #getActiveFromBody() {
        const cls = Array.from(document.body.classList).find(c => c.startsWith('featured-filter-'));
        return cls ? cls.replace('featured-filter-', '') : 'all-items';
    }

    #setActiveButton(value) {
        this.querySelectorAll('[data-featured-filter]').forEach(btn => {
            const btnValue = btn.dataset.value || btn.dataset.paramName || 'all-items';
            btn.classList.toggle('active', btnValue === value);
        });
    }
    
    #onFilterClick = (e) => {
      if (this.#hasDragged) return;

        const button = e.currentTarget;
        const index = button.dataset.filterIndex;
        const value = button.dataset.value;

        document.body.classList.forEach(cls => {
          if (cls.startsWith('featured-filter-')) document.body.classList.remove(cls);
        });
        document.body.classList.add(`featured-filter-${index}`);

        if (button.dataset.paramName === 'all-items') {
          const clearButton = document.querySelector('facet-remove-component[ref="clearButton"]');
          clearButton?.click();
          return;
        }

        // Uncheck ALL filter inputs across all groups without triggering events
        document.querySelectorAll('.facets__inputs-list input:checked').forEach(input => {
          input.checked = false;
        });

        // Find and enable + check the target input
        const filterGroup = document.querySelector('[data-filter-param-name="filter-p-m-custom-featured_filters"]');
        if (!filterGroup) return;

        const input = filterGroup.querySelector(`input[value="${value}"]`);
        if (!input) return;

        input.disabled = false;
        input.checked = true;

        // Trigger a single change event
        input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    #onMouseDown = (e) => {
      this.#isDown = true;
      this.#hasDragged = false;
      this.#startX = e.clientX;
      this.#scrollLeft = this.scrollContainer.scrollLeft;
      this.scrollContainer.classList.add('dragging');
    };

    #onMouseMove = (e) => {
      if (!this.#isDown) return;
      const walk = e.clientX - this.#startX;
      if (Math.abs(walk) > 5) this.#hasDragged = true;
      this.scrollContainer.scrollLeft = this.#scrollLeft - walk;
    };

    #onMouseUp = () => {
      this.#isDown = false;
      this.scrollContainer.classList.remove('dragging');
    };

    #onClick = (e) => {
      if (this.#hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
  });
}